export const REDIRECT_TO_LOGOUT = 'REDIRECT_TO_LOGOUT';
export const SET_PAGE_ERROR = 'SET_PAGE_ERROR';

export const redirectToLogout = () => ({type: REDIRECT_TO_LOGOUT});
export const setPageError = () => ({type: SET_PAGE_ERROR});
